import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

const FooterDisplay = (props) => {
  const userProfile = useSelector((state) => state.userProfile.dataFetched);
  const isSpecial = userProfile?.business?.isSpecial;

  const baseMenuItems = [
    {
      to: "/home",
      icon: "home",
      label: "Home",
    },
    {
      to: "/restaurant",
      icon: "file-tray",
      label: "Marketplace",
    },
    {
      to: "/order-history",
      icon: "card",
      label: "My Order",
    },
    {
      to: "/wallet",
      icon: "card",
      label: "Wallet",
    },
    {
      to: "/settings",
      icon: "settings",
      label: "Tools",
    },
  ];

  const menuItems = baseMenuItems.filter((item) => {
    if (isSpecial) {
      if (item.label === "My Order" || item.label === "Wallet") {
        return false;
      }
    }
    return true;
  });

  const menus = props.menuItems || menuItems;

  return (
    <div className={`footer-cover mt-32 ${props.short ? "short" : ""}`}>
      <div className="footer">
        <div className="footer-display">
          <div>
            <ul>
              {menus.map((item) => (
                <li key={item.key || item.to}>
                  {item.onClick ? (
                    <button
                      onClick={item.onClick}
                      className={item.isActive ? "active" : ""}
                      style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                        background: "none",
                        cursor: "pointer",
                      }}
                    >
                      <div className="icon-cover">
                        <div>
                          <ion-icon
                            name={`${item.icon}${item.isActive ? "" : "-outline"}`}
                          ></ion-icon>
                        </div>
                      </div>
                      <div>
                        <h3>{item.label}</h3>
                      </div>
                    </button>
                  ) : (
                    <NavLink
                      className={({ isActive }) => (isActive ? "active" : "")}
                      to={item.to}
                    >
                      {({ isActive }) => (
                        <>
                          <div className="icon-cover">
                            <div>
                              <ion-icon
                                name={`${item.icon}${isActive ? "" : "-outline"}`}
                              ></ion-icon>
                            </div>
                          </div>
                          <div>
                            <h3>{item.label}</h3>
                          </div>
                        </>
                      )}
                    </NavLink>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterDisplay;
